import { useAtomValue } from 'jotai';
import { useSwrData } from './swrWrapper';
import { userInfoAtom } from '../atoms/utilsAtoms';
import { disableRevalidationForSwrOptions } from '../utils/globals';

export const useFetchPersonalInformationByUserId = () => {
	const userData = useAtomValue(userInfoAtom);
	if (!userData.token) return { data: null };
	const userId = userData.user?.userId ?? userData.user?._id;
	if (!userId) return { data: null };
	const url = `${import.meta.env.VITE_APP_API_URL}/personal/details?userId=${userId}`;
	const data = useSwrData(url, userData.token, disableRevalidationForSwrOptions);
	return data;
};
